/**
 * Created by Liliana Scortea on 04.06.2020.
 */
import Action, { SET_FETCHING_TRANSLATION } from 'constants/action-types'

export default (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_FETCHING_TRANSLATION:
      return action.payload
    default:
      return state
  }
}
